import React from 'react'
import { makeStyles, Grid } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  type: {
    outline: '1px solid var(--color-neutral-700)',
    borderRadius: 'var(--border-radius-lg)',
    padding: theme.layout.padding.thick,
    fontSize: theme.typography.fontSizes.xxl,
    transition: 'outline .2s ease-in-out, background-color .2s ease-in-out',
    '&:hover': {
      backgroundColor: 'var(--color-neutral-500)',
      cursor: 'pointer'
    },
    '&.__selected': {
      outline: '2px solid var(--color-primary-500)',
      backgroundColor: 'color-mix(in srgb, var(--color-primary-300) 15%, transparent)',
      '&:hover': {
        outline: '2px solid var(--color-primary-500)'
      }
    },
    '& article': {
      fontWeight: theme.typography.weights.light
    }
  }
}))

const VisibilitySelector = React.forwardRef(function VisibilitySelector ({ value, onChange }, _) {
  const classes = useStyles()

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <div
          className={clsx(classes.type, { __selected: !value })}
          onClick={() => onChange(false)}
          role='button'
        >
          <header>Visible</header>
          <article>The user will be visible to the firm.</article>
        </div>
      </Grid>
      <Grid item xs={12}>
        <div
          className={clsx(classes.type, { __selected: value })}
          onClick={() => onChange(true)}
          role='button'
        >
          <header>Internal</header>
          <article>
            <p>The user will be hidden from all users who do not have a visibility of <strong>internal</strong>.</p>
            <p>This does not otherwise affect the privileges of the user.</p>
          </article>
        </div>
      </Grid>
    </Grid>
  )
})

VisibilitySelector.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func
}

export default VisibilitySelector
